import React from 'react';
import logoPng from '../../assets/images/logo_top.svg'; // Importe o logo PNG aqui

const Logo = () => {
  return (
    <img src={logoPng} alt="Logo" width="160" /> // Use a tag img para mostrar o logo
  );
};

export default Logo;